import { useEffect, useState } from 'react'
import { AsideActionWrapper } from '~/components/Layout/AsideActionWrapper/AsideActionWrapper'
import type { AsideActionPosition } from '~/types/global'
import { ApplicantActions } from '../../ActionsButtonList/ActionsButtonList'
import {
  applicantModalAsideActions,
  applicantModalAsideActionsTitle
} from './ApplicantModalActions.css'

export const ApplicantModalActions = ({
  applicantId,
  contextOrderId
}: {
  applicantId: number
  contextOrderId?: number
}) => {
  const [currentAction, setCurrentAction] = useState<string | null>(null)
  const [currentHoverAction, setCurrentHoverAction] = useState<string | null>(
    null
  )
  const [availablePositions, setAvailablePositions] = useState<
    AsideActionPosition[]
  >(['modal'])

  useEffect(() => {
    const handleResize = () => {
      setAvailablePositions(
        window.innerWidth > 1600 ? ['bottom', 'modal'] : ['bottom']
      )
    }
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div className={applicantModalAsideActions}>
      <div className={applicantModalAsideActionsTitle}>
        {currentHoverAction ?? currentAction ?? 'Actions rapides'}
      </div>
      <ApplicantActions
        applicantIds={[applicantId]}
        contextOrderId={contextOrderId}
        onActionHover={setCurrentHoverAction}
        onCurrentActionChange={setCurrentAction}
        availablePositions={availablePositions}
        defaultPosition="bottom"
      />
      <AsideActionWrapper position="bottom" />
    </div>
  )
}
